// src/components/common/SocialShare.js

import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../context/ThemeContext';

const ShareContainer = styled.div`
  margin: 2rem 0;
`;

const ShareTitle = styled.h4`
  font-size: 1rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.text};
`;

const ShareButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const ShareButton = styled(motion.a)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  color: white;
  text-decoration: none;
  font-size: 0.9rem;
  
  &.facebook {
    background-color: #3b5998;
  }
  
  &.twitter {
    background-color: #1da1f2;
  }
  
  &.linkedin {
    background-color: #0077b5;
  }
  
  &.whatsapp {
    background-color: #25d366;
  }
  
  i {
    margin-right: 5px;
  }
`;

const SocialShare = ({ url, title, hashtags = [], className }) => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  
  // Utilisez l'URL actuelle si aucune n'est fournie
  const shareUrl = url || window.location.href;
  const shareTitle = title || document.title;
  const shareHashtags = hashtags.join(',');
  
  // Préparer les liens de partage
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}&hashtags=${encodeURIComponent(shareHashtags)}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
  const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`;
  
  return (
    <ShareContainer className={className}>
      <ShareTitle theme={theme}>{t('shareThis')}</ShareTitle>
      <ShareButtons>
        <ShareButton 
          href={facebookUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="facebook"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <i className="fab fa-facebook-f"></i>
          Facebook
        </ShareButton>
        
        <ShareButton 
          href={twitterUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="twitter"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <i className="fab fa-twitter"></i>
          Twitter
        </ShareButton>
        
        <ShareButton 
          href={linkedinUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="linkedin"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <i className="fab fa-linkedin-in"></i>
          LinkedIn
        </ShareButton>
        
        <ShareButton 
          href={whatsappUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="whatsapp"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <i className="fab fa-whatsapp"></i>
          WhatsApp
        </ShareButton>
      </ShareButtons>
    </ShareContainer>
  );
};

export default SocialShare;